import { Component, OnInit, inject } from '@angular/core';
import { UserAuthService } from 'src/app/auth/user-auth.service';
import { APIServiceService } from 'src/app/api/apiservice.service';
import AppError from 'src/app/errors/error';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Auth } from '@angular/fire/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import firebase from 'firebase/compat/app';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {


  signInMessage?: { status: "error" | "success"; message: string};

  loginForm: FormGroup
  passwordResetForm?: FormGroup
  forgotPasswordOn = false
  resetPasswordSent = false
  resetPasswordEmail = ""



  ngOnInit() {
    console.log("URL: ", environment.apiUrl)
  }

  constructor(
    private userAuthService: UserAuthService, 
    private apiService: APIServiceService,
    private afAuth: AngularFireAuth,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl("", [Validators.required, Validators.email]),
      password: new FormControl("", [Validators.required])
    })

    this.passwordResetForm = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email])
    })
  }



  signOut(): void {
   this.userAuthService.signOut();
  }

  async onSubmit() {
    if (this.loginForm.valid) {
      const email = this.loginForm.get('email').value;
      const password = this.loginForm.get('password').value;

  

      try {
      const userCredential = await this.afAuth.signInWithEmailAndPassword(email, password)
        console.log("Successfully signed in", userCredential);
        this.router.navigateByUrl("/calendar")
      } catch(error){
        this.signInMessage = { 
          status: "error",
          message: this._getErrorMessage(error as firebase.FirebaseError)
        };
          setTimeout(() => {
            this.signInMessage = undefined
          }, 10000);
      }
      

      // Perform the login action using userAuthService or apiService
      // this.apiService.login({ email, password }).subscribe(
      //   response => {
      //     // Handle successful login
      //   },
      //   (err: AppError) => {
      //     this.signInErrorMessage = err.message;
      //     setTimeout(() => {
      //       this.signInErrorMessage = '';
      //     }, 5000);
      //   }
      // );
    }
  }

  async resetPassword(value: { email: string }) {
    console.log("Reset password started: ", value)
    this.resetPasswordSent = true
    this.resetPasswordEmail = value.email

     await this.afAuth.sendPasswordResetEmail(value.email)

     this.signInMessage = { 
      status: "success",
      message: "If your email is registered a password reset email has been sent"
    }


  }

  private _getErrorMessage(error: firebase.FirebaseError): string {
    switch (error.code) {
      case 'auth/invalid-email':
        return 'The email address you entered doesn\'t look right. Please check and try again.';
      case 'auth/user-disabled':
        return 'This account has been disabled. If you think this is a mistake, please contact support.';
      case 'auth/user-not-found':
        return 'No account found with that email address.';
      case 'auth/wrong-password':
        return 'That password is incorrect. Please try again or reset your password.';
      case 'auth/too-many-requests':
        return 'We\'ve received too many login attempts from your device. Please wait a few minutes and try again.';
      case 'auth/network-request-failed':
        return 'Network error: please check your internet connection and try again.';
      case 'auth/internal-error':
        return 'Oops—something went wrong on our end. Please try again in a moment.';
      default:
        // For any other FirebaseAuth errors
        return error.message || 'An unknown error occurred. Please try again.';
    }
  }


}
